import '@/styled-system/styles/recipes/property-carousel.css';
import { propertyCarousel } from '@/styled-system/recipes';
import { cx } from '@/styled-system/css';
import type { CarouselGap, CarouselScrollBehavior, CarouselSnapAlign } from './types';

const baseStyles = propertyCarousel();

export const {
  carouselRoot,
  carouselFadeEdge,
  carouselTrack,
  carouselTrackFadePadding,
  carouselItem,
  carouselHeader,
  carouselTitle,
  carouselControls,
  carouselControlButton,
  carouselSkipLinks,
  carouselSkipLink,
  indicatorsContainer,
  dotBase,
  dotInactive,
  dotActive,
  dotInactiveLight,
  dotActiveLight,
} = baseStyles;

type CarouselTrackVariants = {
  gap?: CarouselGap;
  snapAlign?: CarouselSnapAlign;
  scrollBehavior?: CarouselScrollBehavior;
};

export const carouselTrackVariants = (props: CarouselTrackVariants = {}) =>
  propertyCarousel({
    gap: 'md',
    snapAlign: 'start',
    scrollBehavior: 'smooth',
    ...props,
  }).carouselTrack;

export const carouselTitleVariants = ({ level = 3 }: { level?: 1 | 2 | 3 | 4 | 5 | 6 } = {}) =>
  propertyCarousel({
    level: `${level}`,
  }).carouselTitle;

export const combineCarouselClasses = (...classes: Array<string | undefined | false>) => {
  return cx(...classes.filter(Boolean));
};
